import { render, staticRenderFns } from "./ResponsibleTable.vue?vue&type=template&id=3f50f0f5&"
import script from "./ResponsibleTable.vue?vue&type=script&lang=js&"
export * from "./ResponsibleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports